/**
 * Server-side VueHub methods in Vue.Functions.Messages.Functions.VueHub
 */
export const JOIN_GROUP_METHOD = 'JoinGroup';
export const LEAVE_GROUP_METHOD = 'LeaveGroup';
export const GET_COMMUNICATION_METHOD = 'GetCommunication';
